import locationService from "../../services/location";

export const locationsModule = {
  namespaced: true,
  state: {
    locations: null,
  },
  mutations: {
    SET_LOCATIONS: (state, locations) => {
      state.locations = locations;
    },
  },
  getters: {
    locations: (state) => {
      return state.locations;
    },
  },
  actions: {
    clearAll(ctx) {
      ctx.commit("CLEAR_ALL");
    },
    getLocations({ commit }) {
      locationService
        .getLocations()
        .then((response) => {
          commit("SET_LOCATIONS", response);
        })
        .catch((err) => console.error(err));
    },
  },
};
